// AI Generated File
import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { SessionService } from '@monsido/core/session/session.service';
import { DateRangeService } from '@client/app/services/date-range/date-range.service';
import { ParamService } from '@monsido/ng2/core/param/param.service';
import { StatsRepoService } from '@client/app/services/api/stats-repo/stats-repo.service';
import { PipeService } from '@client/app/filters/pipe-transformation.service';
import moment from 'moment';

@Component({
    selector: 'statistics-sources-referrers',
    standalone: false,
    templateUrl: './referrers.component.html',
})
export class StatisticsSourcesReferrersComponent implements OnInit {
    domain: any;
    chartSeries: any[] = [];
    chartLabels: any[] = [];
    chartData: any[] = [];
    summary: any = {};
    chartOptions: any;
    date: any;
    chartOverride: any = [];
    loading: boolean = false;
    pages: any[] = [];
    page: any;
    promise: any;

    constructor (
        private statsRepoService: StatsRepoService,
        private stateService: StateService,
        private paramService: ParamService,
        private translateService: TranslateService,
        private sessionService: SessionService,
        private dateRangeService: DateRangeService,
        private pipeService: PipeService,
    ) {}

    ngOnInit () {
        this.domain = this.sessionService.domain;
        this.chartSeries = [this.translateService.getString('Visits')];
        this.chartLabels = [];
        this.chartData = [];
        this.summary = {};
        this.chartOptions = {
            legend: {
                display: false,
                position: 'bottom',
                fullWidth: true,
                labels: {
                    boxWidth: 20,
                    padding: 20,
                },
            },
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-0',
                        type: 'linear',
                        position: 'left',
                        ticks: {
                            beginAtZero: true,
                            suggestedMax: 4,
                            maxTicksLimit: 5,
                            callback: (value: any) => {
                                return this.pipeService.get('monNumber')(value, '0,0');
                            },
                            min: 0,
                        },
                    },
                ],
                xAxes: [
                    {
                        gridLines: {
                            display: false,
                        },
                        ticks: {
                            autoSkip: false,
                        },
                    },
                ],
            },
            tooltips: {
                intersect: false,
                callbacks: {
                    label: (tooltipItem: any, data: any) => {
                        const num = data.datasets[0].data[tooltipItem.index];
                        const params = {
                            visits: this.pipeService.get('monNumber')(num),
                        };

                        return ' ' + this.translateService.getPlural(num, '1 visit', '[[visits]] visits', params, '');
                    },
                },
            },
        };

        this.date = this.dateRangeService.setRangeDates();
        this.chartOverride = [
            {
                borderColor: ['#36A2EB', '#36A2EB', '#36A2EB', '#36A2EB'],
                backgroundColor: [
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                    'rgba(54, 162, 235, 0.2)',
                ],
                borderWidth: 1,
            },
        ];
        this.updateDateRange();
    }

    private getPage () {
        const domainId = this.stateService.params.domainId;
        const params = {
            limit: 10,
            page: this.page || 1,
            domainId: domainId,
            from: this.date.startDate.format('YYYY-MM-DD'),
            to: this.date.endDate.format('YYYY-MM-DD'),
        };

        this.loading = true;

        this.promise = this.statsRepoService.getReferrers(params)
            .then((data: any) => {
                this.pages = data;
                this.chartLabels = this.pages.map((page: any) => {
                    return page.label;
                });
                this.chartData = [
                    this.pages.map((page: any) => {
                        return page.visits;
                    }),
                ];
            }, () => {})
            .finally(() => {
                this.loading = false;
            });

        this.getSummary(params);
    }

    updateDateRange () {
        this.paramService.setParams({
            from: moment(this.date.startDate),
            to: moment(this.date.endDate),
        });
        this.getPage();
    }

    private getSummary (params: any) {
        params.type = 'referring';
        return this.statsRepoService.getVisitors(params).then((data: any) => {
            const fields = ['visits', 'uniq_visitors', 'bounce_rate', 'avg_time'];
            for (let i = 0; i < fields.length; i++) {
                this.summary[fields[i]] = 0;
                if (Array.isArray(data)) {
                    for (let j = 0; j < data.length; j++) {
                        this.summary[fields[i]] += parseInt(data[j][fields[i]]);
                    }
                }
            }
        }, () => {});
    }
}
